<template>
  <v-dialog v-model="dialog" max-width="620" persistent>
    <template v-slot:activator="{ on }">
      <!--v-btn small light v-on="on">
        Ladda upp fil <v-icon small>mdi-upload</v-icon>
      </v-btn -->
      <v-list-item v-on="on" target="_blank">
        <v-list-item-icon>
          <v-icon>mdi-upload</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Ladda upp dagordning</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
    <v-card>
      <v-card-title>
        Ladda upp dagordning
      </v-card-title>
      <v-card-text>
        <v-file-input accept=".csv" v-model="file" label="Fil"></v-file-input>
        <v-btn
          text
          href="https://firebasestorage.googleapis.com/v0/b/percap-7af8f.appspot.com/o/templates%2Fpercap%20-%20dagordningexempel.csv?alt=media&token=81709d66-7203-467e-bf90-bb2578d1ede0"
          >Ladda ner exempelfil</v-btn
        >
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="close">Avbryt</v-btn>
        <v-btn text color="primary" type="submit" @click="uploadFile"
          >Ladda upp</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    meetingId: String
  },
  data() {
    return {
      dialog: false,
      file: null
    };
  },
  methods: {
    async uploadFile() {
      const success = await this.$store.dispatch("meetings/uploadAgendaItems", {
        meetingId: this.meetingId,
        file: this.file
      });
      if (success) {
        this.close();
      }
    },
    close() {
      this.file = null;
      this.dialog = false;
    }
  }
};
</script>
